/**
 * 档案管理 用能结构
 */
<template>
	 <!-- 面包屑导航 -->
	<div class="container">
    <div style="border-bottom: 4px solid #f4f4f4;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">档案管理</el-breadcrumb-item>
        <el-breadcrumb-item>提前结算</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 计量点列表 -->
    <div class="data-list">
    	<el-form :inline="true"  class="user-search" @submit.native.prevent>
    	  <el-form-item label="搜索：">
    	    <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点名称" v-model="dataParameter.meterPointName"></el-input>
    	  </el-form-item>
        <el-form-item >
          <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点地址" v-model="dataParameter.meterPoint"></el-input>
        </el-form-item>
        <el-form-item  label="所属部门">
          <el-select v-model="deptId" placeholder="请选择" size="small" @change="getTers">
            <el-option v-for="item in depts" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
    	  <el-form-item>
    	    <el-button size="small" type="primary" icon="el-icon-search" @click="handelSearch">搜索</el-button>
    	  </el-form-item>
        <el-form-item>
          <!-- <el-button :disabled="selectJl == ''" :loading="setLoading"  size="small" type="primary" @click="jiesuan">结算</el-button> -->
        </el-form-item>
    	</el-form>
    	<el-table style="width: 100%;"  @selection-change="getSelectJl" size="small" border :data="jlData"  v-loading="loading" :max-height="tableHeight" :header-cell-style="this.$store.state.headerCss">
        <el-table-column  type="index" width="50"></el-table-column>
    		<el-table-column label="ID" prop="id"  width="120" ></el-table-column>
    		<el-table-column label="计量点名称" width="300" prop="meterPointName"  show-overflow-tooltip></el-table-column>
         <el-table-column label="终端名称" prop="terminalInfoName" show-overflow-tooltip  ></el-table-column>
    		<el-table-column label="计量点地址" prop="meterPoint"  show-overflow-tooltip ></el-table-column>
    		<el-table-column label="状态" >
    			<template slot-scope="scope">
    				<div>
    					<el-tag size="mini"  v-if="scope.row.isRunning" type="success">运行中</el-tag>
    					<el-tag size="mini"  v-if="!scope.row.isRunning" type="info">已停止</el-tag>
    				</div>
    			</template>
    		</el-table-column>
        <el-table-column label="能源种类" >
        	<template slot-scope="scope">
        		<div>
        			<el-tag size="mini" type="warning" v-if="scope.row.energyType =='15' ">电</el-tag>
        			<el-tag size="mini" v-if="scope.row.energyType =='16'">水</el-tag>
              <el-tag size="mini"  type="danger" v-if="scope.row.energyType =='18'">热能</el-tag>
        		</div>
        	</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handelYcd(scope.row)">预存单</el-button>
            <el-button size="mini" type="primary" @click="handelJs(scope.row)">结算</el-button>
          </template>
        </el-table-column>
    	</el-table>
    	<!-- 分页组件 -->
    	<Pagination v-bind:child-msg="pageparm"  v-if="showPage"  @callFather="callFather"></Pagination>
    </div>

    <el-dialog :visible.sync="visible" width="50%"  title="预存单">

      <div class="v-content" id="pdfWrap">

        <img v-if="deptId == 101" src="../../assets/img/hyc-logo.jpg"  style="width: 166px;"/>
        <img v-if="deptId == 102" src="../../assets/img/hpc-logo.jpg"  style="width: 166px;"/>
        <h3 class="v-title">电费预存通知单</h3>

        <p class="s-title">尊敬的 <span class="u-line">{{curData.appletUserName}}</span>用户：</p>
        <p>
          根据预付费系统显示，您租赁的铺位编号为  <span class="u-line">{{curData.meterPointName}}</span>  ，电表ID：<span class="u-line">{{curData.meterPointId}}</span>，
          电表编号：<span class="u-line">{{curData.meterPoint}}</span>，
          剩余费用约<span class="u-line">{{curData.balance}}</span>元，报警下限值：<span class="u-line">{{curData.lowerAlarm || 0}}</span>，日用电量约为<span class="u-line">{{curData.dayDegree}}</span>度，
          可用余额约为<span class="u-line">{{curData.balanceUsedDay}}</span>天，为了保障您店铺正常用电，
          请在收到本通知单<span class="u-line">{{curData.balanceUsedDay}}</span>日内到我司财务窗口完成电费预存充值。
        </p>
		<p>（日用电量和余额可用天数均以上月数据计算获得，仅供参考）</p>
        <p>（建议预充值下限<span class="u-line">{{curData.lowerRecharge || 0}}</span>元/次）</p>

        <div class="bankInfo">
          <p>{{curData.companyAddress}}的开户行及账号：</p>
          <p>{{curData.bankAddress}} {{curData.idCard}}</p>
        </div>
        <div>
          <p><span style="font-weight: bold;">您剩余可使用电量为0时，电量管理系统将自动停止供电服务。</span>请您注意并提前做好停电后财产保管和适当人身安全保护的各项准备工作，因停电给您带来的一切后果，由您自行承担！</p>
        </div>


        <p>感谢您对我司工作的支持和配合，祝您生意兴隆，生活愉快！</p>
        <div class="pageDown">
          <!-- <img style="width: 200px;" src="../../assets/img/zhang.png" /> -->
          <p v-if="deptId == 101">东莞市汇一城商业发展有限公司</p>
          <p v-if="deptId == 102">东莞市恒生物业管理有限公司</p>
          <p>{{curData.noticeYear}}年{{curData.noticeMonth}}月{{curData.noticeDay}}日</p>
        </div>
      </div>
    	<div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="printOut">生成PDF</el-button>
    		<el-button size="small" @click='visible = false'>取消</el-button>

    	</div>
    </el-dialog>

    <!-- 结算 -->
    <el-dialog title="结算" :visible.sync="jsVisible" width="30%" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="jsForm" ref="reditForm">

    		<el-form-item label="计量点名称:">
    			<div>{{jsForm.meterPointName}}</div>
    		</el-form-item>

    		<el-form-item label="计量点读数" >
    			<el-input size="small" v-model="jsForm.meterReading" type="number"   placeholder="计量点读数" ></el-input>
          <el-button  @click="getDs" :loading="loadBm" size="small" type="primary" >获取读数</el-button>
    		</el-form-item>


    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="jsVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="saveLoad" class="title" @click="saveJs">保存</el-button>
    	</div>
    </el-dialog>



	</div>
</template>

<script>
	import PremsButton from "@/views/permission/PreButtom";
	import { provinceAndCityData,CodeToText } from 'element-china-area-data'
	import Pagination from '../../components/Pagination'



	import {
	 findMeterInfoList,
	 getDepartmentTerminalInfoLis,
	 getTerminalInfoByDepId,
	 deleteMeterInfo,
	 getAllConfigurationList,
	 getAllDataItemList,
	 getTerminalInfoListByAddMeterInfo,
   generateBillDataAdvance,
   getMeterPointParam,
   getMeterPointParamPoi,
   generateNotice,
   getPower,

	} from '../../api/energyMG'
  import JSPDF from "jspdf";
  import html2Canvas from "html2canvas";
	export default{
		data(){
			return{
        selectJz:false,
        zdVisible:false,
        isCheck:false,
        loadDel:false,
        setLoading:false,
        jsVisible:false,
        saveLoad:false,
        gVisible:false,
        isRun:false,
				canGetRoom:false,
        visible:false,
        jsForm:{
          appletUserIds:'',
          meterId:"",
          meterReading:"",
          meterPointName:'',
        },
				options: provinceAndCityData,
				selectedOptions: [],
				suoshu:'',
        user:{},
				formInline:{
					type:""
				},

        deptId:0,
        depts:[],
        downloadLoadin:false,
        checkForm:{
          username:"",
          password:""
        },
        mName:"",
        switchForm:{
          id:"",
          rtuAddr:"",
          meterAddr:"",
          passWord:"",
          switchType:"2",

        },
        zdList:[],
        loadingZd:false,
        showZd:false,
        selectJl:'',
				depLoading:true,
        loadingExport:false,
				dataParameter:{
					terIds:JSON.stringify([]),
					currentPage: 1,
					pageSize: 10,
					meterPoint:'',
					meterPointName:'',
					energyType:'',
          isRunning:'',
				},
        switchVisible:false,
        loadSave:false,
				dataItemList:[
				],
				showDataItemInfo:"",
				energyType:[],
				roomList:[],
        commAddress:"",
				communicationProtocolList:[],//规约类型集合
				communicationTypeList:[], //通讯方式
				loading:true,

				 // 分页参数
				pageparm: {
				  currentPage: 1,
				  pageSize: 10,
				  total: 0
				},
        showPage:true,
        curData:{},
				terIds:{},
        loadBm:false,
				currtypeId:0,
				meterInfo:{},
				tetInfo:[],//集中器数据
        tableHeight:0,
         dataSource:'2',
				treeDaa: [],
				loadLoadin:false,
				defaultItems:[],
				jzProps:{
					label: function( data,node ){
						console.log(data)
					},
					children: 'deps',

				},
				jltitle:'',
				jlData:[]

			}
		},

    mounted(){
      this.$nextTick(() => {

      	this.tableHeight = window.innerHeight - 260
      })
    },
		created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

			this.choiseOpeion = ''
			this.getJzData();

			// this.getTerInfo();

			//this.$store.dispatch('getDepts')

		},
		 // 注册组件
		components: {
		  Pagination,
		  PremsButton
		},

		computed:{

		},


		methods:{

      handelYcd(row){
        this.curData = row

        generateNotice({meterId:row.id}).then(res => {
          if(res.status == 1){
            if(res.data.msg){
              this.$message.error(res.data.msg)
            }else{
              this.curData = res.data
              this.visible = true
            }

          }else{
            this.$message.error('操作失败！')
          }
        })
      },

      handelJs(row){
        this.jsVisible = true
        this.jsForm.meterPointName = row.meterPointName
        this.jsForm.meterId = row.id
        this.jsForm.meterReading = ''

      },

      getDs(){
        this.loadBm = true
        getPower({meterInfoId:this.jsForm.meterId}).then(res => {
          this.loadBm = false
          if(res.status == 1){
            this.jsForm.meterReading = res.data.bm
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      saveJs(){
        this.saveLoad = true
        generateBillDataAdvance(this.jsForm).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.jsVisible = false
           // this.jsPrint = res.data
            //this.shoujuVisbel  = true
            this.getData()
          }else{
            this.$message.error(res.msg)
          }
        })
      },


      printOut() {
        let pdfDom = document.querySelector("#pdfWrap"); //这里绑定你要转换的页面

        pdfDom.style.background = "#FFFFFF";
        let _this = this;
        let pdfPage = null;
        html2Canvas(pdfDom, {
          //开始截图,这里可以设置一些截图时的属性
          logging: false,
          dpi: window.devicePixelRatio*4,
          scale:4
          //height:3000,
        }).then((canvas) => {
          // 开始将图片转换为PDF
          var pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
          var ctx = canvas.getContext("2d")
          var a4w = 190;
          var a4h = 257 // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
          var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度
          var renderedHeight = 0

          while (renderedHeight < canvas.height) {
            var page = document.createElement("canvas")
            page.width = canvas.width
            page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

            // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext("2d").putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(
              imgHeight, canvas.height - renderedHeight)), 0, 0)
            pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height /
              page.width)) // 添加图像到页面，保留10mm边距

            renderedHeight += imgHeight
            if (renderedHeight < canvas.height) {
              pdf.addPage()
            } // 如果后面还有内容，添加一个空页
            // delete page;
          }
          pdf.save('电费预存通知单.pdf')
          this.$message.success('操作成功，正在下载')

        })
      },

      getTers(e){
        getTerminalInfoByDepId({depId: e}).then(res => {
          if (res.status == 1) {
            if (res.data.length) {
              let arr = []
              res.data.forEach( item => {
              	arr.push({ id: item})
              })
              this.dataParameter.terIds = JSON.stringify(arr)



            } else {
              //解决bug 如果获得的集中器是个空数组 查询数据将会是所有的数据 ，所以这个时候 给个不存在 的id
              this.dataParameter.terIds = [{id:0}]
            }
            this.getData();
          } else {
            this.$message.error(res.msg)
          }
        })
      },



      getSelectJl(data){

        this.selectJl = data.map(item => item.id).join(',')

      },

      handelSearch(){
        this.dataParameter.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(()=>{
          this.showPage = true
        })


      },

      jiesuan(){
        this.setLoading = true
        generateBillDataAdvance({ meterInfoIds:this.selectJl }).then(res => {
          this.setLoading = false
          if(res.status == 1){
            this.$message.success('操作成功！')
          }else{
            this.$message.error('操作失败！')
          }
        })
      },


			//获取数据
			getJzData(){
				this.depLoading = true;
        let param = {
          dataSource:this.dataSource
        }
				getDepartmentTerminalInfoLis(param).then(res => {
					if(res.status == 1){
						//数据改造
						this.depts = res.data.menuDepList
            this.deptId = res.data.menuDepList[0].id

						this.depLoading = false;
						this.getTers(this.deptId)
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},


			chagenData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.chagenData(item.deps)
					}
				})

				return  data
			},
			handleChange(e){
				let param = {
					province : CodeToText[e[0]],
					city     : CodeToText[e[1]]
				}
				this.getroom(param)
			},

			getroom(param){
				getRoomList(param).then( res =>{
					if(res.status == 1){
						this.canGetRoom = true

						this.roomList = res.data
					}
				})
			},
			getData(){
				this.loading = true

				findMeterInfoList(this.dataParameter).then(res => {
					if(res.status == 1){
						this.loading = false
						this.jlData = res.data.data

						// 分页赋值
						this.pageparm.currentPage = this.dataParameter.currentPage
						this.pageparm.pageSize = this.dataParameter.pageSize

						this.pageparm.total = res.data.totalCount
					}else{
						this.loading = false
						this.$message.error(res.msg)
					}
				})
				.catch( err =>{
					this.loading = false
					this.$message.error(err)
				})
			},
			// 分页插件事件
			callFather(parm) {

			  this.dataParameter.currentPage = parm.currentPage
			  this.dataParameter.pageSize = parm.pageSize
			  this.getData()
			},
		}

	}
</script>

<style scoped>
  .pageDown{
    text-align: right;
    position: relative;
    padding: 20px 0;
  }
  .pageDown img{
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .pageDown p{
    margin: 0;
  }
  .v-content{
    font-size: 16px;
    line-height: 36px;
    padding: 0 50px;
  }
  .v-content p{
    text-indent: 20px;
  }
  .v-content .bankInfo{
    color: #000000;
    padding: 10px 0px;
    line-height: 15px;
  }
  .v-title{
    text-align: center;
    font-weight: normal;
    font-size: 30px;
    margin: 0;
    padding-bottom: 30px;
  }
  .u-line{

    padding: 1px 10px;
    text-decoration: underline;
  }
  .s-title{
    font-size: 18px;
    color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/views/prepayment/jiesuan.vue